import { canRunLiveModelWalk } from "~/lib/siteglue/agent-ready/walk-agents";
import {
  WALK_OUTCOME_INCONCLUSIVE,
  WALK_OUTCOME_INCONCLUSIVE_HELP,
  WALK_OUTCOME_LIVE,
  WALK_OUTCOME_LIVE_HELP,
  WALK_OUTCOME_SIMULATION,
  WALK_OUTCOME_SIMULATION_HELP,
  WALK_OUTCOME_UNSUPPORTED,
  WALK_OUTCOME_UNSUPPORTED_HELP,
} from "~/lib/siteglue/landing-redesign/copy";

export type WalkOutcomeKind = "live" | "simulation" | "unsupported" | "inconclusive";

export function classifyWalkOutcome(input: {
  status?: string | null;
  mode?: string | null;
  executionMode?: string | null;
  agentId?: string | null;
  pageCount?: number | null;
  fetchedUrls?: string[] | null;
}): WalkOutcomeKind {
  const failed = input.status === "failed" || input.status === "cancelled";
  const pages = input.pageCount ?? input.fetchedUrls?.length ?? 0;
  if (failed || (input.status === "ready" && pages === 0 && input.mode !== "from_scan")) {
    return "inconclusive";
  }
  const liveRuntime =
    input.executionMode === "live" ||
    (input.mode === "live" && input.executionMode === "provider_model_simulation");
  if (liveRuntime && canRunLiveModelWalk(input.agentId ?? undefined)) {
    return "live";
  }
  if (!canRunLiveModelWalk(input.agentId ?? undefined)) {
    if (input.mode === "from_scan" || input.executionMode === "from_scan") return "simulation";
    return "unsupported";
  }
  if (input.mode === "from_scan" || input.executionMode === "from_scan") return "simulation";
  return "inconclusive";
}

export function walkOutcomeLabel(kind: WalkOutcomeKind): string {
  if (kind === "live") return WALK_OUTCOME_LIVE;
  if (kind === "simulation") return WALK_OUTCOME_SIMULATION;
  if (kind === "unsupported") return WALK_OUTCOME_UNSUPPORTED;
  return WALK_OUTCOME_INCONCLUSIVE;
}

export function walkOutcomeHelp(kind: WalkOutcomeKind): string {
  if (kind === "live") return WALK_OUTCOME_LIVE_HELP;
  if (kind === "simulation") return WALK_OUTCOME_SIMULATION_HELP;
  if (kind === "unsupported") return WALK_OUTCOME_UNSUPPORTED_HELP;
  return WALK_OUTCOME_INCONCLUSIVE_HELP;
}

export function walkPickerOutcome(agentId: string | undefined): WalkOutcomeKind {
  return canRunLiveModelWalk(agentId) ? "live" : "unsupported";
}
